export default "__VITE_ASSET__BXvIeAqr__"